// Mock data for workouts — replace with real API calls once curl is shared
export const MOCK_WORKOUTS = [
	{
		id: 'w1',
		name: 'Barbell Squat',
		muscleGroup: 'Legs',
		equipment: 'Barbell',
		gender: 'Unisex',
		level: 'Intermediate',
		defaultSets: 4,
		defaultReps: '8-12',
		defaultRestSeconds: 90,
		videoUrl: '',
		imageUrl: '',
		instructions: 'Stand with feet shoulder-width apart, bar across upper back. Squat until thighs are parallel.',
	},
	{
		id: 'w2',
		name: 'Push Up',
		muscleGroup: 'Chest',
		equipment: 'Bodyweight',
		gender: 'Unisex',
		level: 'Beginner',
		defaultSets: 3,
		defaultReps: '15-20',
		defaultRestSeconds: 60,
		videoUrl: '',
		imageUrl: '',
		instructions: 'Start in plank position. Lower chest to ground and push back up.',
	},
	{
		id: 'w3',
		name: 'Pull Up',
		muscleGroup: 'Back',
		equipment: 'Pull-up Bar',
		gender: 'Male',
		level: 'Intermediate',
		defaultSets: 4,
		defaultReps: '6-10',
		defaultRestSeconds: 90,
		videoUrl: '',
		imageUrl: '',
		instructions: 'Hang from bar with overhand grip. Pull chest to bar.',
	},
	{
		id: 'w4',
		name: 'Deadlift',
		muscleGroup: 'Back',
		equipment: 'Barbell',
		gender: 'Unisex',
		level: 'Advanced',
		defaultSets: 4,
		defaultReps: '5-8',
		defaultRestSeconds: 120,
		videoUrl: '',
		imageUrl: '',
		instructions: 'Stand with bar over mid-foot. Hinge at hips and drive through heels.',
	},
	{
		id: 'w5',
		name: 'Hip Thrust',
		muscleGroup: 'Glutes',
		equipment: 'Barbell',
		gender: 'Female',
		level: 'Beginner',
		defaultSets: 3,
		defaultReps: '12-15',
		defaultRestSeconds: 60,
		videoUrl: '',
		imageUrl: '',
		instructions: 'Sit with upper back on bench, bar over hips. Drive hips up.',
	},
	{
		id: 'w6',
		name: 'Dumbbell Lunge',
		muscleGroup: 'Legs',
		equipment: 'Dumbbell',
		gender: 'Unisex',
		level: 'Beginner',
		defaultSets: 3,
		defaultReps: '12',
		defaultRestSeconds: 60,
		videoUrl: '',
		imageUrl: '',
		instructions: 'Hold dumbbells at sides. Step forward and lower knee to just above floor.',
	},
	{
		id: 'w7',
		name: 'Romanian Deadlift',
		muscleGroup: 'Hamstrings',
		equipment: 'Barbell',
		gender: 'Unisex',
		level: 'Intermediate',
		defaultSets: 4,
		defaultReps: '10-12',
		defaultRestSeconds: 90,
		videoUrl: '',
		imageUrl: '',
		instructions: 'Hold bar at hips, hinge forward keeping back flat, lower until stretch felt in hamstrings.',
	},
	{
		id: 'w8',
		name: 'Lateral Raise',
		muscleGroup: 'Shoulders',
		equipment: 'Dumbbell',
		gender: 'Unisex',
		level: 'Beginner',
		defaultSets: 3,
		defaultReps: '15',
		defaultRestSeconds: 45,
		videoUrl: '',
		imageUrl: '',
		instructions: 'Hold dumbbells at sides, raise arms to shoulder height and lower slowly.',
	},
	{
		id: 'w9',
		name: 'Plank',
		muscleGroup: 'Core',
		equipment: 'Bodyweight',
		gender: 'Unisex',
		level: 'Beginner',
		defaultSets: 3,
		defaultReps: '45s',
		defaultRestSeconds: 30,
		videoUrl: '',
		imageUrl: '',
		instructions: 'Hold forearm plank position with body in a straight line.',
	},
	{
		id: 'w10',
		name: 'Glute Bridge',
		muscleGroup: 'Glutes',
		equipment: 'Bodyweight',
		gender: 'Female',
		level: 'Beginner',
		defaultSets: 3,
		defaultReps: '15-20',
		defaultRestSeconds: 45,
		videoUrl: '',
		imageUrl: '',
		instructions: 'Lie on back, feet flat, drive hips up squeezing glutes at top.',
	},
];

export const MOCK_WORKOUT_TEMPLATES = [
	{
		id: 't1',
		name: '4-Week Beginner Strength',
		durationDays: 28,
		gender: 'Unisex',
		level: 'Beginner',
		goal: 'Strength',
		days: Array.from({ length: 28 }, (_, i) => ({
			dayNumber: i + 1,
			isRestDay: [0, 3, 6, 7, 10, 13, 14, 17, 20, 21, 24, 27].includes(i),
			title: [0, 3, 6, 7, 10, 13, 14, 17, 20, 21, 24, 27].includes(i) ? 'Rest' : `Day ${i + 1}`,
			items: [0, 3, 6, 7, 10, 13, 14, 17, 20, 21, 24, 27].includes(i)
				? []
				: [
						{
							id: `item-${i}-1`,
							workoutId: 'w1',
							workoutName: 'Barbell Squat',
							sets: 3,
							reps: '8-12',
							restSeconds: 90,
							notes: '',
							order: 1,
						},
						{
							id: `item-${i}-2`,
							workoutId: 'w2',
							workoutName: 'Push Up',
							sets: 3,
							reps: '15',
							restSeconds: 60,
							notes: '',
							order: 2,
						},
				  ],
		})),
	},
	{
		id: 't2',
		name: '8-Week Fat Loss',
		durationDays: 56,
		gender: 'Female',
		level: 'Intermediate',
		goal: 'Fat Loss',
		days: Array.from({ length: 56 }, (_, i) => ({
			dayNumber: i + 1,
			isRestDay: i % 7 === 6,
			title: i % 7 === 6 ? 'Rest' : `Day ${i + 1}`,
			items: i % 7 === 6 ? [] : [{ id: `item-${i}-1`, workoutId: 'w5', workoutName: 'Hip Thrust', sets: 4, reps: '12-15', restSeconds: 60, notes: '', order: 1 }],
		})),
	},
];

export const MOCK_WORKOUT_PLANS = [
	{
		id: 'p1',
		name: '4-Week Beginner Strength',
		customerId: 'cust1',
		customerName: 'Rajesh Kumar',
		templateId: 't1',
		startDate: '2026-04-01',
		endDate: '2026-04-28',
		durationDays: 28,
		currentDay: 22,
		status: 'active',
		days: MOCK_WORKOUT_TEMPLATES[0].days,
	},
	{
		id: 'p2',
		name: '8-Week Fat Loss',
		customerId: 'cust2',
		customerName: 'Priya Nair',
		templateId: 't2',
		startDate: '2026-02-01',
		endDate: '2026-03-30',
		durationDays: 56,
		currentDay: 56,
		status: 'completed',
		days: MOCK_WORKOUT_TEMPLATES[1].days,
	},
];
